import styled from 'styled-components';
import { ADVENTURE_GREEN } from '../colors';
import { fontSpacingKeys, fontSpacingMixin } from '../mixins/typography';
import { getPx } from '../helpers/common';
import { LIST_INLINE_HORIZONTAL_OFFSET, LIST_INLINE_VERTICAL_OFFSET } from '../List/constants';
import { withOmitProps } from '../helpers/elements';
import { Base as BaseSpacing } from './constants/base.spacing';
import { isDefined } from '../helpers/defined';
import { styleArrayForBreakpoints, styleForBreakpoints } from '../helpers/media-style';
import { textAlign } from '../style/text-align';
import { paddingHalfVertical } from '../style/padding-vertical';
import { marginVerticalHalfNegative } from '../style/margin-vertical-negative';
const UL_VERTICAL_SPACING = 2;
const Ul = styled.ul.withConfig(withOmitProps(['withIcons', 'listStyleNone', 'inline', 'expanded', 'noWrap', 'horizontalOffset', 'verticalOffset', 'textAlignCenter', 'textAlignLeft', 'textAlignRight', 'textAlign', ...fontSpacingKeys]))`
  list-style: none;
  padding: 0;
  ${marginVerticalHalfNegative(UL_VERTICAL_SPACING)}

  ${({
  textAlign: value
}) => isDefined(value) ? textAlign(value) : ''}
  ${({
  textAlignCenter
}) => textAlignCenter ? `text-align: center;` : ''}
  ${({
  textAlignLeft
}) => textAlignLeft ? `text-align: left;` : ''}
  ${({
  textAlignRight
}) => textAlignRight ? `text-align: right;` : ''}
  ${({
  inline,
  horizontalOffset
}) => styleArrayForBreakpoints([inline, horizontalOffset ?? LIST_INLINE_HORIZONTAL_OFFSET], ([inline, horizontalOffset]) => inline ? `
            margin-left: calc(-${getPx(horizontalOffset)} / 2);
            margin-right: calc(-${getPx(horizontalOffset)} / 2);
          ` : '')} 
  ${({
  expanded,
  verticalOffset
}) => styleArrayForBreakpoints([expanded, verticalOffset ?? LIST_INLINE_VERTICAL_OFFSET], ([expanded, verticalOffset]) => expanded ? `
            margin-top: calc(-${getPx(verticalOffset)} / 2);
            margin-bottom: calc(-${getPx(verticalOffset)} / 2);
          ` : '')}
  ${({
  inline,
  noWrap
}) => styleForBreakpoints(inline, inline => inline && noWrap ? `white-space: nowrap;` : '')}

  & > li {
    ${paddingHalfVertical(UL_VERTICAL_SPACING)}
    ${({
  inline,
  horizontalOffset
}) => styleArrayForBreakpoints([inline, horizontalOffset ?? LIST_INLINE_HORIZONTAL_OFFSET], ([inline, horizontalOffset]) => inline ? `
              display: inline-flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              box-sizing: border-box;
              vertical-align: middle;
              padding-left: calc(${getPx(horizontalOffset)} / 2);
              padding-right: calc(${getPx(horizontalOffset)} / 2);
            ` : '')}
    ${({
  expanded,
  verticalOffset
}) => styleArrayForBreakpoints([expanded, verticalOffset ?? LIST_INLINE_VERTICAL_OFFSET], ([expanded, verticalOffset]) => expanded ? `
              margin-bottom: 0;
              padding-top: calc(${getPx(verticalOffset)} / 2);
              padding-bottom: calc(${getPx(verticalOffset)} / 2);
            ` : '')}
  }
  & > li::before {
    content: '\\2022';
    color: ${ADVENTURE_GREEN};
    margin: 0 8px 0 2px;
    ${({
  listStyleNone,
  inline
}) => styleForBreakpoints(inline, inline => inline || listStyleNone ? `
            content: none;
            margin: 0;
          ` : '')}
    ${({
  withIcons
}) => withIcons ? `
          content: '';
          width: 0;
          margin: 0;
        ` : ''}
  }
  & > li > ul,
  & > li > ol {
    padding-left: 32px;
    ${({
  listStyleNone,
  inline
}) => styleForBreakpoints(inline, inline => inline || listStyleNone ? `padding-left: 0;` : '')}
  }
  ${fontSpacingMixin(BaseSpacing)}
`;
export default Ul;